import {useHistory, useIsLaunchTeaserPage} from '@aboutyou/router';
import {useState} from 'react';

export const HIDE_HEADER_QUERY_PARAM = 'hideheader';
export const HIDE_FOOTER_QUERY_PARAM = 'hidefooter';

export const useFullScreenView = () => {
  const history = useHistory();
  const isOnLaunchTeaserPage = useIsLaunchTeaserPage();
  const [{hideHeaderByQueryParam, hideFooterByQueryParam}] = useState(() => {
    const queryParams = new URLSearchParams(history.location.search);
    return {
      hideHeaderByQueryParam: queryParams.get(HIDE_HEADER_QUERY_PARAM) === '1',
      hideFooterByQueryParam: queryParams.get(HIDE_FOOTER_QUERY_PARAM) === '1',
    };
  });

  const isHeaderDisabled = hideHeaderByQueryParam || isOnLaunchTeaserPage;
  const isFooterDisabled = hideFooterByQueryParam || isOnLaunchTeaserPage;

  return {
    isHeaderDisabled,
    isFooterDisabled,
  };
};
